var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulgaria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 17.5536 39.56 15.2101 38.756 13.0435L20 12.1739L1.24398 13.0435C0.440078 15.2101 0 17.5536 0 20C0 22.4464 0.440078 24.7899 1.24398 26.9565L20 27.8261L38.756 26.9566C39.56 24.7899 40 22.4464 40 20Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.5993 40 35.9302 34.5725 38.7561 26.9565H1.24402C4.06988 34.5725 11.4007 40 20 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24402 13.0435H38.7561C35.9302 5.4275 28.5993 0 20 0C11.4007 0 4.06988 5.4275 1.24402 13.0435V13.0435Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulgaria);
export default __webpack_public_path__ + "static/media/bulgaria.8ff5daee2286ac41397c8a5cee48f72e.svg";
export { ForwardRef as ReactComponent };